import React from 'react';
import dayjs from 'dayjs';
import AvatarStack from '@/_elements/AvatarStack/AvatarStack';
import { GoToChannel, GoToTeamSettings } from '@/_elements/Links';
import { getDuration } from '../../../../_helpers';
import ConferenceRecordings from './ConferenceRecordings';

const ConferenceRow = ({ item, index, query, onUpdateItem }) => {
    return (
        <tr key={item._id || item.id}>
            <td>{(query.page - 1) * 10 + index + 1}.</td>
            <td className="text-left">
                <GoToTeamSettings team={item.room?.team} showAvatar={true} />
            </td>
            <td className="text-left">
                <GoToChannel channel={item.room} />
            </td>
            <td className="text-left">{item.startedAt ? dayjs(item.startedAt).format('MMMM D, YYYY h:mm A') : '-'}</td>
            <td className="text-left">{getDuration(item.endedAt, item.startedAt)}</td>
            <td className="text-left">
                <span
                    className={`badge ${
                        item?.status === 'completed'
                            ? 'badge-success'
                            : item?.status === 'ongoing'
                              ? 'badge-danger'
                              : 'badge-info'
                    }`}
                >
                    {item?.status}
                </span>
            </td>
            <td>
                <AvatarStack
                    stack={[...(item?.allParticipants ?? [])].map((p) => ({
                        username: p.name,
                        id: p._id ?? p.id,
                        avatar: p.avatar,
                    }))}
                    previewSize={2}
                />
            </td>
            <td>
                <ConferenceRecordings
                    item={item}
                    onUpdateItem={(updatedItem) =>
                        onUpdateItem({
                            _id: updatedItem?._id,
                            recordings: updatedItem?.recordings || [],
                            recordingCompositionStatus: updatedItem?.recordingCompositionStatus,
                        })
                    }
                />
            </td>
        </tr>
    );
};

export default ConferenceRow;
